export default "__VITE_ASSET__nK6CXoEFqAfGfhlY7WPU7g__"